var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 346H16V496H496V346Z",
    fill: "#2ECC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 331H16V346H496V331Z",
    fill: "#E32D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 181H16V331H496V181Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V166H496V16Z",
    fill: "#4BB7C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 166H16V181H496V166Z",
    fill: "#E32D3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.925 57.2754C82.3981 57.2754 64.9561 74.7174 64.9561 96.2441C64.9562 117.771 82.3981 135.213 103.925 135.213C106.141 135.213 108.31 135.037 110.425 134.682C91.9899 131.589 77.9562 115.558 77.9561 96.2441C77.9561 76.9305 91.9899 60.899 110.425 57.8066C108.31 57.4513 106.141 57.2754 103.925 57.2754Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.678 119.631L187.269 127.045L190.976 128.249",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/UZ.07a46befd993fee92321a9cffff4cc90.svg";
export { ForwardRef as ReactComponent };